import { render, staticRenderFns } from "./ticketPanel.vue?vue&type=template&id=2bbd6eed&scoped=true&"
import script from "./ticketPanel.vue?vue&type=script&lang=js&"
export * from "./ticketPanel.vue?vue&type=script&lang=js&"
import style0 from "./ticketPanel.vue?vue&type=style&index=0&id=2bbd6eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd6eed",
  null
  
)

export default component.exports